import slice from './slice';

const webhookRegistrationReducer = slice.reducer;

export const { setFieldWebhookRegistration } = slice.actions;

export default webhookRegistrationReducer;
